import { AxiosResponse } from 'axios'
import Request from 'redux/config/services/Request'
import {
  ReimbursementStatus,
  ResolveReimbursementPayload,
} from 'redux/reimbursements/reimbursementsTypes'

// Admin endpoint - process receipt for an employee
export const processReceiptForEmployee = (
  downloadUrl: string,
  contentType: string,
  employeeId: string
): Promise<AxiosResponse> => {
  return Request.post('/hr/reimbursement/process_receipt/', {
    downloadUrl,
    contentType,
    employeeId,
  })
}

// Admin endpoint - resolve a reimbursement (approve, reject, partial, etc.)
export const resolveReimbursement = (
  receiptId: string,
  payload: ResolveReimbursementPayload
): Promise<AxiosResponse> => {
  return Request.post(
    `/hr/reimbursement/receipts/${receiptId}/resolve/`,
    payload
  )
}

// Admin endpoint - auto approve eligible reimbursements for an employer
export const autoApproveEligibleReimbursements = (
  employerId: string
): Promise<AxiosResponse> => {
  return Request.post(`/hr/reimbursement/${employerId}/auto_approve/`, {})
}

// Admin endpoint - confirm receipt details for an employee
export const confirmReceiptDetailsForEmployee = (
  downloadUrl: string,
  employeeId: string,
  receipts: {
    receiptId: string
    merchant: string
    amount: number
    receiptDate: string
    expenseType: string
    merchantCategory: string
    merchantCurrency: string
    merchantAmount: number
    employeeNote?: string | null
    manualReview: boolean
  }[]
): Promise<AxiosResponse> => {
  const payload = {
    download_url: downloadUrl,
    employee_id: employeeId,
    receipts: receipts.map((r) => ({
      receipt_id: r.receiptId,
      merchant: r.merchant,
      amount: r.amount,
      receipt_date: r.receiptDate,
      expense_type: r.expenseType,
      merchant_category: r.merchantCategory,
      merchant_currency: r.merchantCurrency,
      merchant_amount: r.merchantAmount,
      employee_note: r.employeeNote,
      manual_review: r.manualReview,
    })),
  }
  return Request.post('/hr/reimbursement/receipt_details/confirm/', payload)
}
